import axios from './axios'

export async function makeUserLogout() {
    try {
      const token = localStorage.getItem('token').replaceAll('"', '');
      const response = await axios.get(`api/user/logout`, {
        headers: {
          Authorization: "Bearer " + token
        }
      });
      localStorage.removeItem('token');
      localStorage.clear();
      return response.data;
    } catch (error) {
      console.error("Logout failed:", error);
      return { error: "Logout failed" };
    }
  }
  
  let lastActive = Date.now();
  
  function trackActivity() {
    lastActive = Date.now(); 
  }
  document.addEventListener('click', trackActivity);
  document.addEventListener('mousemove', trackActivity);
  document.addEventListener('keypress', trackActivity);
  
  
  function checkInactivity() {
    const inactiveTime = (Date.now() - lastActive) / 1000; 
    if (inactiveTime > 600) { 
      makeUserLogout()
        .then(() => window.location.replace('/login'))
        .catch(error => console.error(error));
    }
  }
  
  setInterval(checkInactivity, 60000);
  trackActivity();